import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {breakpoints} from '@/Themes/Mistubishi/breakpoints.js';

export const typography = {
    fontFamily: '"Roboto", "Avenir Next", "Arial"',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontWeight: 700,
        fontSize: '2rem',
        textWrap: 'pretty',
        marginBottom: '0.35em',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '3rem',
            marginBottom: '0.5em',
            '&::after': {
                fontSize: '4rem',
            },
        },
        '&::after': {
            content: '"."',
            fontSize: '3rem',
            display: 'inline-block',
            width: '12px',
            height: '12px',
        },
    },
    h2: {
        fontFamily: '"Roboto", "Arial"',
        fontWeight: 700,
        fontSize: '1.5rem',
        textWrap: 'pretty',
        marginBottom: '2.5rem',
        position: 'relative',
        paddingBottom: '0.3em',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '1.75rem',
            '&::after': {
                fontSize: '1.75rem',
            },
        },
    },
    h2_withDecoration: {
        fontFamily: '"Roboto", "Arial"',
        fontWeight: 400,
        fontSize: '1.5rem',
        textWrap: 'pretty',
        marginBottom: '2.5rem',
        position: 'relative',
        paddingBottom: '0.3em',
        align: 'center',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '1.75rem',
            '&::after': {
                fontSize: '1.75rem',
            },
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: '50%',
            height: '0.13rem',
            backgroundColor: '#e5eaed',
            width: '3em',
            webkitTransform: 'translate(-50%)',
            msTransform: 'translate(-50%)',
            transform: 'translate(-50%)',
        },
    },
    h3: {
        fontFamily: '"Avenir Next LT Pro", "Roboto", "Arial"',
        fontWeight: 700,
        fontSize: '1.313rem',
        textWrap: 'pretty',
        marginBottom: '0.35em',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            marginBottom: '0.5em',
        },
    },
    h4: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontWeight: 700,
        fontSize: '1.1rem',
        textWrap: 'pretty',
        marginBottom: '0.35em',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '1.2rem',
            marginBottom: '0.5em',
            '&::after': {
                fontSize: '1.3rem',
            },
        },
    },
    h6: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontWeight: 500,
        fontSize: '.5rem',
        textWrap: 'pretty',
        marginBottom: '0.35em',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '2rem',
            marginBottom: '0.5em',
        },
    },
    subtitle1: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontSize: '1.125rem',
        marginBottom: '0.35em',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '1.25rem',
            marginBottom: '0.5em',
        },
    },
    subtitle2: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontWeight: 700,
        fontSize: '1.125rem',
        marginBottom: '0.35em',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '1.25rem',
            marginBottom: '0.5em',
        },
    },
    body1: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontWeight: 400,
        fontSize: '0.875rem',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '1rem',
        },
    },
    body2: {
        fontFamily: '"Roboto", "Arial"',
        fontWeight: 400,
        fontSize: '0.875rem',
        [`@media (min-width:${breakpoints.lg}px)`]: {
            fontSize: '1rem',
        },
    },
    caption: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontWeight: 400,
        fontSize: '0.75rem',
    },
    button: {
        fontFamily: '"Avenir Next", "Roboto", "Arial"',
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: '1.5',
        textTransform: 'none',
    },
};
